<template>
    <div class="overflow-hidden" v-show="isShow">
        <div :id="'ovl' + popupId" v-if="isShowOverlay" class="overlay fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex justify-center items-center h-[100vh] transition-all duration-300"></div>
        <div v-if="isShow" class="bg-white/95 backdrop-blur-md fixed inset-0 overflow-hidden md:rounded-2xl rounded-t-2xl shadow-2xl border border-white/20 draggable"
            :class="[{ 'animate-popupFadeIn': isVisible, 'animate-popupFadeOut': !isVisible}, customCss]"
            :id="popupId"
            >
            <div ref="headerPopup" class="popup-header flex justify-between items-center border-b border-gray-100/50 w-full sticky top-0 z-50 max-h-[55px] bg-white/80 backdrop-blur-md">
                <div class="p-[12px] w-full" v-if="isShowHeader">
                    <div class="font-bold text-gray-800 text-center flex-1 text-[16px] tracking-wide">{{ title }}</div>
                    <div v-if="isShowClose" class="h-[30px] w-[30px] text-gray-400 hover:text-gray-700 text-[20px] flex justify-center items-center absolute right-[12px] top-[12px] transition-colors"><font-awesome-icon :icon="['fas', 'xmark']" class="cursor-pointer" @click="closePopup()"/></div>
                </div>
                <slot v-else name="header"></slot>
            </div>
            <div ref="bodyPopup" class="p-[10px] no-scrollbar h-full" :class="{'overflow-y-auto max-h-[calc(100%-55px)]': isScroll, 'pb-[90px]': isShowFooter}">
                <slot name="body"></slot>
            </div>
            <div v-if="isShowFooter" ref="footerPopup" class="absolute bottom-0 w-full p-[10px] flex justify-center bg-white/95 backdrop-blur-md border-t border-gray-100 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] rounded-b-2xl z-50">
                <slot name="footer"></slot>
            </div>
            <div class="el-resizable-handle el-resizable-handle-top"></div>
            <div class="el-resizable-handle el-resizable-handle-bottom"></div>
            <div class="el-resizable-handle el-resizable-handle-left"></div>
            <div class="el-resizable-handle el-resizable-handle-right"></div>
            <div class="el-resizable-handle el-resizable-handle-corner-bottom-right"></div>
            <div class="el-resizable-handle el-resizable-handle-corner-bottom-left"></div>
            <div class="el-resizable-handle el-resizable-handle-corner-top-right"></div>
            <div class="el-resizable-handle el-resizable-handle-corner-top-left"></div>
        </div>
    </div>
</template>

<script>
import { faCakeCandles } from '@fortawesome/free-solid-svg-icons';

const convertSize = function(size, fullWidth, fullHeight, direct) {
    if (typeof size === "string") {
        if (size.includes("vw")) {
            return parseInt(size.replace("vw", "")) * fullWidth / 100;
        } else if (size.includes("vh")) {
            return parseInt(size.replace("vh", "")) * fullHeight / 100;
        } else if (size.includes('%')) {
            return parseInt(size.replace("%", "")) * (direct === 'width' ? fullWidth : fullHeight) / 100;
        } else {
            return parseInt(size.replace("px", ""));
        }
    } else {
        return size;
    }
}
export default {
    components: {

    },
    props: {
        isShowFooter: {
            type: Boolean,
            default: true,
        },
        isShowHeader: {
            type: Boolean,
            default: true,
        },
        isShow: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '',
        },
        height: {
            type: String,
            default: '200',
        },
        width: {
            type: String,
            default: '300',
        },
        minWidth: {
            type: Number | String,
            default: 100,
        },
        minHeight: {
            type: Number | String,
            default: 100,
        },
        isShowClose: {
            type: Boolean,
            default: false,
        },
        isCanDrag: {
            type: Boolean,
            default: true,
        },
        customCss: {
            type: String | Object | Array,
            default: "",
        },
        isShowOverlay: {
            type: Boolean,
            default: true
        },
        isScroll: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isVisible: true,
            popupId: null,
            zCounter: 0
        };
    },
    computed: {
    },
    created() {
        this.popupId = "popup" + Math.floor(Math.random() * 1000000);
    },
    mounted() {
        this.zCounter = this.$app.zIndexPopup
        this.$nextTick( () => {
            const dlg = document.getElementById(this.popupId)
            if(this.isShowOverlay) {
                const ovl = document.getElementById(`ovl${this.popupId}`)
                ovl.style.zIndex = this.zCounter
            }
            dlg.style.zIndex = this.zCounter
            dlg.style.height = this.height
            dlg.style.width = this.width
            this.centerPopup()
            this.initDraggableHandler()
            this.initResizableHandler()
        })
    },
    methods: {
        bringToFront() {
            if (!this.$app.zIndexPopup) {
                this.$app.zIndexPopup = 100
            }
            this.$app.zIndexPopup++
            this.zCounter = this.$app.zIndexPopup
            let popupDiv = '#' + this.popupId;
            var dlg   = document.querySelector(popupDiv)
            dlg.style.zIndex = this.zCounter
        },
        closePopup() {
            this.isVisible = false
            setTimeout(() => {
                this.$emit('closed');
            }, 500);
        },

        initResizableHandler() {
            let self = this
            let div = '#' + this.popupId
            const element = document.querySelector(div);
            const resizers = document.querySelectorAll(div + ' .el-resizable-handle')

            var rect,
            fullWidth = window.innerWidth,
            fullHeight = window.innerHeight,
            _minW = 300,
            _minH = 300,
            _maxX, _maxY,
            _startX, _startY,
            _startW, _startH,
            _leftPos, _topPos


            if (this.minWidth) {
                _minW = convertSize(this.minWidth, fullWidth, fullHeight, 'width')
            }
            if (this.minHeight) {
                _minH = convertSize(this.minHeight, fullWidth, fullHeight, 'height')
            }
            function _getOffset(elm) {
                var rect = elm.getBoundingClientRect(),
                    offsetX = window.scrollX || document.documentElement.scrollLeft,
                    offsetY = window.scrollY || document.documentElement.scrollTop;
                return {
                    left: rect.left + offsetX,
                    top: rect.top + offsetY,
                    right: rect.right + offsetX,
                    bottom: rect.bottom + offsetY
                }
            }

            function _getOriginals(evt) {
                rect = _getOffset(element);
                _maxX = Math.max(
                    document.documentElement["clientWidth"],
                    document.body["scrollWidth"],
                    document.documentElement["scrollWidth"],
                    document.body["offsetWidth"],
                    document.documentElement["offsetWidth"]
                );
                _maxY = Math.max(
                    document.documentElement["clientHeight"],
                    document.body["scrollHeight"],
                    document.documentElement["scrollHeight"],
                    document.body["offsetHeight"],
                    document.documentElement["offsetHeight"]
                );
                if (rect.right > _maxX)
                    _maxX = rect.right;
                if (rect.bottom > _maxY)
                    _maxY = rect.bottom;
                _startX = evt.pageX;
                _startY = evt.pageY;
                _startW = element.clientWidth;
                _startH = element.clientHeight;
                _leftPos = rect.left;
                _topPos = rect.top;

            }

            for (let i = 0; i < resizers.length; i++) {
                const currentResizer = resizers[i];
                currentResizer.addEventListener('mousedown', function (e) {
                    e.preventDefault()
                    _getOriginals(e)
                    window.addEventListener('mousemove', _resize)
                    window.addEventListener('mouseup', _stopResize)
                })
                function resizeDirection(direction) {
                    return currentResizer.classList.value.includes(direction)
                }
                function _resize(evt) {
                    self.isResizing = true
                    var dw, dh, w, h;
                    switch(true ) {
                        case resizeDirection('corner-bottom-right'):
                            dw = evt.pageX - _startX;
                            dh = evt.pageY - _startY;
                            if (_leftPos + _startW + dw > _maxX)
                                dw = _maxX - _leftPos - _startW;
                            if (_topPos + _startH + dh > _maxY)
                                dh = _maxY - _topPos - _startH;
                            w = _startW + dw;
                            h = _startH + dh;
                            if (w < _minW)
                                w = _minW;
                            if (h < _minH)
                                h = _minH;
                            element.style.width = w + 'px';
                            element.style.height = h + 'px';
                            break;

                        case resizeDirection('corner-bottom-left'):
                            dw = _startX - evt.pageX;
                            dh = evt.pageY - _startY;
                            if (_leftPos - dw < 0)
                                dw = _leftPos;
                            if (_topPos + _startH + dh > _maxY)
                                dh = _maxY - _topPos - _startH;
                            w = _startW + dw;
                            h = _startH + dh;
                            if (w < _minW) {
                                w = _minW;
                                dw = w - _startW;
                            }
                            if (h < _minH)
                                h = _minH;
                            element.style.width = w + 'px';
                            element.style.height = h + 'px';
                            element.style.left = (_leftPos - dw) + 'px';
                            break;
                        case resizeDirection('corner-top-right'):
                            dw = evt.pageX - _startX;
                            dh = _startY - evt.pageY;
                            if (_leftPos + _startW + dw > _maxX)
                                dw = _maxX - _leftPos - _startW;
                            if (_topPos - dh < 0)
                                dh = _topPos;
                            w = _startW + dw;
                            h = _startH + dh;
                            if (w < _minW)
                                w = _minW;
                            if (h < _minH) {
                                h = _minH;
                                dh = h - _startH;
                            }
                            element.style.width = w + 'px';
                            element.style.height = h + 'px';
                            element.style.top = (_topPos - dh) + 'px';
                            break;
                        case resizeDirection('corner-top-left'):
                            dw = _startX - evt.pageX;
                            dh = _startY - evt.pageY;
                            if (_leftPos - dw < 0)
                                dw = _leftPos;
                            if (_topPos - dh < 0)
                                dh = _topPos;
                            w = _startW + dw;
                            h = _startH + dh;
                            if (w < _minW) {
                                w = _minW;
                                dw = w - _startW;
                            }
                            if (h < _minH) {
                                h = _minH;
                                dh = h - _startH;
                            }
                            element.style.width = w + 'px';
                            element.style.height = h + 'px';
                            element.style.left = (_leftPos - dw) + 'px';
                            element.style.top = (_topPos - dh) + 'px';
                            break;
                        case resizeDirection('right'):
                            dw = evt.pageX - _startX;
                            if (_leftPos + _startW + dw > _maxX)
                                dw = _maxX - _leftPos - _startW;
                            w = _startW + dw;
                            if (w < _minW)
                                w = _minW;
                            element.style.width = w + 'px';
                            break;
                        case resizeDirection('left'):
                            dw = _startX - evt.pageX;
                            if (_leftPos - dw < 0)
                                dw = _leftPos;
                            w = _startW + dw;
                            if (w < _minW) {
                                w = _minW;
                                dw = w - _startW;
                            }
                            element.style.width = w + 'px';
                            element.style.left = (_leftPos - dw) + 'px';
                            break;
                        case resizeDirection('bottom'):
                            dh = evt.pageY - _startY;
                            if (_topPos + _startH + dh > _maxY)
                                dh = _maxY - _topPos - _startH;
                            h = _startH + dh;
                            if (h < _minH)
                                h = _minH;
                            element.style.height = h + 'px';
                            break;
                        case resizeDirection('top'):
                            dh = _startY - evt.pageY;
                            if (_topPos - dh < 0)
                                dh = _topPos;
                            h = _startH + dh;
                            if (h < _minH) {
                                h = _minH;
                                dh = h - _startH;
                            }
                            element.style.height = h + 'px';
                            element.style.top = (_topPos - dh) + 'px';
                            break;
                    }
                }

                function _stopResize() {
                    window.removeEventListener('mousemove', _resize)
                    setTimeout(() => {
                        self.isResizing = false
                    }, 200);
                }
            }
        },

        initDraggableHandler() {
            let self = this
            let popupDiv = '#' + this.popupId;
            var dlg   = document.querySelector(popupDiv)
            var title = document.querySelector(popupDiv + ' .popup-header')
            if (!dlg || !title) return;
            dlg.offsetX = 0
            dlg.offsetY = 0

            const getViewportSize = function() {
                const width  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                const height = window.innerHeight|| document.documentElement.clientHeight|| document.body.clientHeight;
                return {
                    width, height
                }
            }

            const move = function(e) {
                var left = e.pageX - dlg.offsetX
                var top  = e.pageY - dlg.offsetY
                left = Math.max(left, 0)
                top  = Math.max(top , 0)
                var viewport = getViewportSize()
                left = Math.min(left, viewport.width  - dlg.offsetWidth)
                top  = Math.min(top , viewport.height - dlg.offsetHeight)
                dlg.style.margin     = '0px'
                dlg.style.left       = left + 'px'
                dlg.style.top        = top  + 'px'
            }

            const up = function() {
                console.log('huỷ mousemove và mouseup')
                removeEventListener('mousemove', move)
                removeEventListener('mouseup'  , up  )
            }

            const down = function(e) {
                if (!self.isCanDrag) return
                self.bringToFront()
                dlg.offsetX = (e.pageX - dlg.offsetLeft)
                dlg.offsetY = (e.pageY - dlg.offsetTop )
                addEventListener('mousemove', move)
                addEventListener('mouseup'  , up  )
            }
            title.addEventListener('mousedown', down)
        },

        centerPopup() {
            let popupWidth = this.width;
            let popupHeight = this.height;
            let windowWidth = window.innerWidth;
            let windowHeight = window.innerHeight;
            function calcSize(size, direct) {
                let fullWidth = window.innerWidth;
                let fullHeight = window.innerHeight;
                return convertSize(size, fullWidth, fullHeight, direct)
            }
            popupWidth = calcSize(popupWidth, 'width')
            popupHeight = calcSize(popupHeight, 'height')
            let left = (windowWidth - popupWidth) / 2;
            let top = (windowHeight - popupHeight) / 2;
            let style = document.createElement("style");
            style.id = this.popupId
            style.innerHTML = `
                #${this.popupId} {
                    left: ${left}px;
                    top: ${top}px;
                    width: ${popupWidth}px;
                    height: ${popupHeight}px;
                }
            `;
            document.body.appendChild(style);
        },
    },

};
</script>

<style scoped lang="scss">
.no-scrollbar::-webkit-scrollbar {
    display: none;
}

.no-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
}
.draggable {
    position: fixed;
    .popup-header {
        cursor: move;
        touch-action: pinch-zoom;
        user-select: none;
    }
}
.el-resizable {
    display: block;
    position: relative;
}

.el-resizable-handle {
    position: absolute;
    z-index: 50;
}

.el-state-disabled .el-resizable-handle {
    cursor: default;
}

.el-resizable-handle-left,
.el-resizable-handle-right {
    top: 0;
    height: 100%;
    width: 3px;
}

.el-resizable-handle-left {
    left: 0;
    cursor: e-resize;
}

.el-resizable-handle-right {
    right: 0;
    cursor: e-resize;
}

.el-resizable-handle-bottom,
.el-resizable-handle-top {
    left: 0;
    width: 100%;
    height: 3px;
}

.el-resizable-handle-top {
    top: 0;
    cursor: s-resize;
}

.el-resizable-handle-bottom {
    bottom: 0;
    cursor: s-resize;
}

.el-resizable-handle-corner-bottom-left,
.el-resizable-handle-corner-bottom-right,
.el-resizable-handle-corner-top-left,
.el-resizable-handle-corner-top-right {
    width: 6px;
    height: 6px;
}

.el-resizable-handle-corner-bottom-right,
.el-resizable-handle-corner-top-left {
    cursor: se-resize;
}

.el-resizable-handle-corner-bottom-left,
.el-resizable-handle-corner-top-right {
    cursor: ne-resize;
}

.el-resizable-handle-corner-bottom-left,
.el-resizable-handle-corner-top-left {
    left: 0;
    border-bottom-right-radius: 100%;
}

.el-resizable-handle-corner-bottom-right,
.el-resizable-handle-corner-top-right {
    right: 0;
    border-bottom-left-radius: 100%;
}

.el-resizable-handle-corner-top-left,
.el-resizable-handle-corner-top-right {
    top: 0;
}

.el-resizable-handle-corner-bottom-left,
.el-resizable-handle-corner-bottom-right {
    bottom: 0;
}

.el-draggable {
    left: 0;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
}

.el-draggable.el-state-disabled,
.el-state-disabled .el-draggable {
    cursor: default;
}

.el-draggable-clone {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2147483647;
}

.el-clearfix::after,
.el-clearfix::before {
    display: table;
    content: "";
    line-height: 0;
}
@keyframes popupFadeIn {
    0% {
        opacity: 0;
        transform: translateY(10px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes popupFadeOut {
    0% {
        opacity: 1;
        transform: translateY(0);
    }

    100% {
        opacity: 0;
        transform: translateY(10px);
    }
}

.animate-popupFadeIn {
    animation: popupFadeIn 0.5s forwards;
}

.animate-popupFadeOut {
    animation: popupFadeOut 0.5s forwards;
}
</style>